export enum Locale {
    German = 'de',
    English = 'en',
    SwissGerman = 'de_ch',
    French = 'fr',
    Italien = 'it_ch',
}
